export { default } from './SkeletonLine';
export * from './SkeletonLine.types';
